<script setup lang="ts">
import {
  getCategoryRoute,
  getTranslatedProperty,
} from "@shopware/helpers";

const { navigationElements } = useNavigation({ type: "footer-navigation" });
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);
</script>
<template>
  <div class="container">
    <template v-for="navigationElement in navigationElements" :key="navigationElement.id">
      <template v-if="navigationElement.translated.customFields?.custom_navigation_config_show_in_mobile_menu">
        <span class="text-md font-bold text-black">{{ getTranslatedProperty(navigationElement, "name") }}</span>
        <ul class="flex flex-col gap-2.5 leading-6 mt-4">
          <li 
            v-for="navigationChild in navigationElement.children"
            :key="navigationChild.id" 
            class="text-base text-black"
          >
            <NuxtLink
             :to="formatLink(getCategoryRoute(navigationChild))"
             :target="
                navigationChild.externalLink || navigationChild.linkNewTab
                  ? '_blank'
                  : ''
              "
             class="hover:text-primary transition-colors duration-300"
            >
              {{ getTranslatedProperty(navigationChild, "name") }}
            </NuxtLink>
          </li>
        </ul>
      </template>
    </template>
  </div>
</template>